export default __webpack_public_path__ + "static/media/moneyIconBlue.447d778c.svg";